<template>
  <div :class="[showAppointAssess ? 'div-shade-show videoPage' : 'videoPage']">
    <div class="header-banner-container">
      <headerCom ref="headerComDom"></headerCom>
      <div class="head-banner-content">
        <div class="head-banner-title">视频</div>
        <div class="head-banner-subtitle">让我们与您一起来分享</div>
      </div>
    </div>
    <div class="main-container">
       <div class="main-content">
         <div class="main-seach-container">
           <div :class="[isShowAllCategory ? 'main-seach-category-content' : 'main-seach-category-content categoryContentMaxHeight']">
            <div :class="[v.isChecked ? 'active main-seach-category' : 'main-seach-category']" v-for="v in categoryData" @click="categoryChecked(v.id)">{{v.name}}</div>
            <div class="clearboth"></div>
           </div>

           <div class="main-seach-category-more" v-if="!isShowAllCategory && isShowCategoryMore" @click="toCategoryMore">更多</div>
           <div class="main-seach-category-more" v-if="isShowAllCategory && isShowCategoryMore" @click="toCategoryMore">收起</div>

           <div class="main-search-content">
             <img class="main-search-icon" src="../assets/icon_search.png">
             <input class="main-search-input" v-model="nameQuery" v-on:input="getVideoData(0)" type="text" placeholder="搜索文章关键字"/>
             <div class="clearboth"></div>
           </div> 
           <div class="clearboth"></div>
         </div>
       </div> 
      <div class="main-content">
        <div class="main-video" v-for="(v,index) in hrData.slice(0,6)" @click="toVideoInfo(v.id,$event)">
          <div class="main-video-media-container">
            <video class="main-video-media-file" :src="v.videoSrc" :poster="v.videoPosterPath" onloadedmetadata="getVideoTime(this)"></video>
            <!--<img class="main-video-media-file" src="../assets/viedoPage_img_random.png">-->
            <div class="main-video-media-browse-container">
              <img class="main-video-media-browse-img" src="../assets/videoCard_icon_views.png">
              <div class="main-video-media-browse">已播放{{v.readQuantitie}}次</div>
              <div class="clearboth"></div>
            </div> 
            <div class="main-video-media-time videoTimeTxt"></div>
          </div>
          <div class="main-video-content">
              <div class="main-video-category-container">
                <div class="main-video-category" v-for="vc in v.categoryData">{{vc.name}}</div>
                <div class="clearboth"></div>
              </div>
              <div class="main-video-title">{{v.title}}</div>
          </div>
          <div class="clearboth"></div>
        </div>

        <div class="clearboth"></div>
        
        <div class="main-banner main-banner3">
          <div class="main-banner-img-container">
            <img class="main-banner-img" src="../assets/banner_bg_img.png" />
            <div class="main-banner-content">
              <div class="main-banner-title">企业员工关系管理问题的避风岗</div>
              <div class="main-banner-info4">
                专家顾问为您提供面对面2小时免费评估
              </div>
              <div class="main-banner-btn" @click="toShowAppointAssess($event)">
                免费上门评估
              </div>
            </div>
          </div>
          <div class="clearboth"></div>
        </div>

        <div class="main-video" v-for="(v,index) in hrData.slice(6,9)" @click="toVideoInfo(v.id,$event)">
          <div class="main-video-media-container">
            <video class="main-video-media-file" :src="v.videoSrc" :poster="v.videoPosterPath"  onloadedmetadata="getVideoTime(this)"></video>
            <!--<img class="main-video-media-file" src="../assets/viedoPage_img_random.png">-->
            <div class="main-video-media-browse-container">
              <img class="main-video-media-browse-img" src="../assets/videoCard_icon_views.png">
              <div class="main-video-media-browse">已播放{{v.readQuantitie}}次</div>
              <div class="clearboth"></div>
            </div>
            <div class="main-video-media-time videoTimeTxt"></div>
          </div>
          <div class="main-video-content">
              <div class="main-video-category-container">
                <div class="main-video-category" v-for="vc in v.categoryData">{{vc.name}}</div>
                <div class="clearboth"></div>
              </div>
              <div class="main-video-title">{{v.title}}</div>
          </div>
          <div class="clearboth"></div>
        </div>
       
        <div class="clearboth"></div>

      </div> 
      <div class="main-content">
        <div class="main-page-container">
          <div class="main-page">
            <div class="main-last-page-img-container" v-if="curIndex!=0" @click="toPage(-2)">
                <img class="main-page-img" src="../assets/pageNum_icon_next.png">
            </div>
            <div :class="[{'main-page-number':v.page!=-1},{'main-page-ellipsis':v.page==-1},{'active':v.isChecked}]" v-for="(v,index) in pageData"  @click="toPage(v.page)">{{ v.page == -1 ? '···' : v.page }}</div>
            <div class="main-next-page-img-container" v-if="curIndex+1!=maxCurIndex" @click="toPage(-3)">
                <img class="main-page-img" src="../assets/pageNum_icon_next.png">
            </div>
            <div class="clearboth"></div>
          </div>
        </div>
      </div>    

    </div>


    <foot></foot>
 
    <popup 
      v-if="showAppointAssess" 
      :showAppointAssess="showAppointAssess"
      @closePop="closePop" @toShowAppointAssessSuccess="toShowAppointAssessSuccess"></popup>
    <popup 
      v-if="showAppointAssessSuccess" 
      :showAppointAssessSuccess="showAppointAssessSuccess"
      @closePop="closePop"></popup>
  </div>

</template>

<script>
  import headerCom from '@/components/Header.vue'
  import foot from '@/components/Footer.vue'
  import popup from '@/components/popup.vue'
  import axios from "axios";

  export default {
    data() {
      return {
        curIndex: 0, //页码
        pageSize: 9, //每页数
        maxCurIndex: 0, //最大页码
        lawLabelId:0, //选中标签id，0全部标签
        nameQuery: '', //标题模糊搜索
        categoryData:[], //标签数据
        hrData:[], //视频数据
        pageData: [],//分页数据 {page：显示页码，isChecked：true/false} page-1是...

        isShowAllCategory: false, //标签展开收起
        isShowCategoryMore: false, //标签展开收起按钮显示

        showAppointAssess: false,
        showAppointAssessSuccess: false,
      }
    },
    components: {
      headerCom,
      foot,
      popup
    },
    created() {
       document.title = '视频_薪领航管理咨询有限公司';
      if(this.$route.params.lawLabelId!=null){
        this.lawLabelId = this.$route.params.lawLabelId//详情页点相关标签跳过来
      }
      if(this.lawLabelId!=0){
        this.categoryData.push({ id: 0, isChecked: false, name: "全部标签" })
      }else{
        this.categoryData.push({ id: 0, isChecked: true, name: "全部标签" })  
      }
      let params = {};
      params.curIndex = this.curIndex;
      params.pageSize = this.pageSize;
      if(this.lawLabelId!=0){
        params.lawLabelId = this.lawLabelId;
      }
      axios
        .get("pilotage/videoList", {params: params})
        .then((res) => {
          if(res!=null && res.data!=null){
            for(let i=0;i<res.data.categoryData.length;i++){
              if(this.lawLabelId==res.data.categoryData[i].id){
                this.categoryData.push({id: res.data.categoryData[i].id, isChecked: true, name: res.data.categoryData[i].name})   
              }else{
                this.categoryData.push({id: res.data.categoryData[i].id, isChecked: false, name: res.data.categoryData[i].name})   
              }
            }
            
            //标签是否显示 更多 按钮
            var categoryCount = res.data.categoryData.length
            var showCategoryCount = Math.floor((window.innerWidth - 360) * 0.6 / 118) * 3 - 1
            if(categoryCount > showCategoryCount){
              this.isShowCategoryMore = true
            }

            //最大页码数
            this.maxCurIndex = Math.floor(res.data.maxCurIndex/9)
            if(res.data.maxCurIndex%this.pageSize!=0){
              this.maxCurIndex = this.maxCurIndex + 1
            }
            
            //分页
            if(this.curIndex>=(this.maxCurIndex-this.pageSize-1)){
              for(let i=(this.maxCurIndex-this.pageSize-1>0?this.maxCurIndex-this.pageSize-1:1);i<=this.maxCurIndex;i++){
                if(i==(this.curIndex+1)){
                  this.pageData.push({page:i,isChecked:true})
                }else{
                  this.pageData.push({page:i,isChecked:false})
                }
              }
            }else{
              for(let i=0;i<this.pageSize;i++){
                if(i==0){
                  this.pageData.push({page:this.curIndex,isChecked:true})
                }else if(i==(this.pageSize-2)){
                  this.pageData.push({page:-1,isChecked:false})
                }else if(i==(this.pageSize-1)){
                  this.pageData.push({page:this.maxCurIndex,isChecked:false})
                }else{
                  this.pageData.push({page:this.curIndex+i,isChecked:false})
                }
              }
            }

            for(let j=0;j<res.data.hrData.length;j++){
              let id = res.data.hrData[j].id
              let title = res.data.hrData[j].title
              let readQuantitie = 0
              if(res.data.hrData[j].readQuantitie!=null){
                readQuantitie = res.data.hrData[j].readQuantitie
              }
              
              let videoSrc = res.data.hrData[j].videoSrc
              let videoPosterPath = res.data.hrData[j].videoPosterPath

              //视频标签
              let categoryData = []
              if(res.data.hrData[j].articleLabelList!=null){
                for(let k=0;k<res.data.hrData[j].articleLabelList.length;k++){
                  let categoryId = res.data.hrData[j].articleLabelList[k].lawLabelId
                  let categoryName = res.data.hrData[j].articleLabelList[k].lawLabelName
                  categoryData.push({id:categoryId,name:categoryName})
                }
              }

              this.hrData.push({id:id,title:title,readQuantitie:readQuantitie,categoryData:categoryData,videoSrc:videoSrc,videoPosterPath:videoPosterPath})
            }
          }
        })
        .catch((res) => {
          
        });
    },
    mounted() {	
      document.addEventListener("click", (e) => {
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,0,0,x,y);
      });				
    },
    methods: {
      //标签点击选中
      categoryChecked(id){
        for(let i=0;i<this.categoryData.length;i++){
          if(id==this.categoryData[i].id){
            this.categoryData[i].isChecked = true
            this.lawLabelId = this.categoryData[i].id
            this.getVideoData(0) 
          }else{
            this.categoryData[i].isChecked = false
          }
        }
      },
      
      //显示全部标签
      toCategoryMore(){
        this.isShowAllCategory = !this.isShowAllCategory
      },
      
      //跳页码
      toPage(page){
        if(page==-1){
          return false;
        }else if(page==-2){
          this.curIndex = this.curIndex - 1
        }else if(page==-3){
          this.curIndex = this.curIndex + 1
        }else{
          this.curIndex = page - 1
        }
        this.getVideoData(this.curIndex)
      },
      //获取视频数据
      getVideoData(curIndex){
         let params = {};
         params.curIndex = curIndex;
         params.pageSize = this.pageSize;
         params.lawLabelId = this.lawLabelId;
         params.nameQuery = this.nameQuery;
         axios
          .get("pilotage/videoList", {params: params})
          .then((res) => {
            this.hrData = []
            this.pageData = []
            this.maxCurIndex = 0
            for(let j=0;j<res.data.hrData.length;j++){
              let id = res.data.hrData[j].id
              let title = res.data.hrData[j].title
              let readQuantitie = 0
              if(res.data.hrData[j].readQuantitie!=null){
                readQuantitie = res.data.hrData[j].readQuantitie
              }
              
              let videoSrc = res.data.hrData[j].videoSrc
              let videoPosterPath = res.data.hrData[j].videoPosterPath

              //视频标签
              let categoryData = []
              if(res.data.hrData[j].articleLabelList!=null){
                for(let k=0;k<res.data.hrData[j].articleLabelList.length;k++){
                  let categoryId = res.data.hrData[j].articleLabelList[k].lawLabelId
                  let categoryName = res.data.hrData[j].articleLabelList[k].lawLabelName
                  categoryData.push({id:categoryId,name:categoryName})
                }
              }

              this.hrData.push({id:id,title:title,readQuantitie:readQuantitie,categoryData:categoryData,videoSrc:videoSrc,videoPosterPath:videoPosterPath})
            }

            //最大页码数
            this.maxCurIndex = Math.floor(res.data.maxCurIndex/9)
            if(res.data.maxCurIndex%this.pageSize!=0){
              this.maxCurIndex = this.maxCurIndex + 1
            }
            
            //分页
            if(this.curIndex>=(this.maxCurIndex-this.pageSize-1)){
              for(let i=(this.maxCurIndex-this.pageSize-1>0?this.maxCurIndex-this.pageSize-1:1);i<=this.maxCurIndex;i++){
                if(i==(this.curIndex+1)){
                  this.pageData.push({page:i,isChecked:true})
                }else{
                  this.pageData.push({page:i,isChecked:false})
                }
              }
            }else{
              for(let i=0;i<this.pageSize;i++){
                if(i==0){
                  this.pageData.push({page:this.curIndex,isChecked:true})
                }else if(i==(this.pageSize-2)){
                  this.pageData.push({page:-1,isChecked:false})
                }else if(i==(this.pageSize-1)){
                  this.pageData.push({page:this.maxCurIndex,isChecked:false})
                }else{
                  this.pageData.push({page:this.curIndex+i,isChecked:false})
                }
              }
            }

          })
          .catch((res) => {});  
      },
      //跳转视频详情页
      toVideoInfo(id,e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,'/videoInfo',0,id,x,y);
        this.$router.push({
          path:'/videoInfo',
          query:{
              id:id
          }
        })
      },
      //打开 免费上门评估弹窗 弹窗
      toShowAppointAssess(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,1,0,x,y);
        this.showAppointAssess = true
        document.documentElement.scrollTop = 0;
      },
      //打开 预约上门评估成功 弹窗
      toShowAppointAssessSuccess(e){
        let scrollTop = document.documentElement.scrollTop;
        let x = e.x;
        let y = Math.floor(e.y + scrollTop);
        this.$refs.headerComDom.toVisitPage(this.$route.path,this.$route.path,2,0,x,y);
        this.showAppointAssess = false;
        this.showAppointAssessSuccess = true;
        document.querySelector('body').setAttribute('style', 'width: 100%;height: 100%;overflow: hidden;');

      },
      //关闭弹窗
      closePop(){
        this.showAppointAssess = false;
        this.showAppointAssessSuccess = false;
        document.body.removeAttribute('style');
      },
      
    },
  }
</script>

<style>
  .div-shade-show {
    height: 1180px;
    overflow: hidden;
  }

  .videoPage .header-banner-container {
    background: url('../assets/video_heroBanner_bg_img.png');
    background-size: cover;
    padding-bottom: 29.166%;
    /*2880*840图片高宽比*/
  }

  
  .videoPage .main-video:nth-of-type(-3n+4){
    margin-left: 180px;
  }
  .videoPage .main-video:nth-of-type(3n+9){
    margin-left: 180px;
  }
 
  
  .videoPage .main-banner {
    margin: 50px auto auto auto;
  }

</style>



// WEBPACK FOOTER //
// src/pages/video.vue